import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  TextField,
} from '@mui/material';
import { post } from 'api';
import { enqueueSnackbar } from 'notistack';
import * as yup from 'yup';

const enquirySchema = yup.object({
  firstName: yup.string().required('First Name is mandatory'),
  middelName: yup.string().required('Middel Name is mandatory'),
  lastName: yup.string().required('Last Name is mandatory'),
  appliedCapacity: yup
    .number()
    .typeError('Applied Capacity in kw')
    .required('Applied Capacity in kw')
    .min(1, 'Applied Capacity in kw'),
  amount: yup
    .number()
    .typeError('Amount is Required')
    .required('Amount is Required')
    .min(1, 'Amount is Required'),
});

export default function CustomerCreate({ open, setOpen, enquiry }) {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(enquirySchema),
    defaultValues: {
      firstName: '',
      middelName: '',
      lastName: '',
      appliedCapacity: 0,
      amount: 0,
    },
  });

  const onClose = () => {
    reset();
    setOpen(false);
  };

  const submitStock = async (data) => {
    try {
      data.enquiryId = enquiry._id;
      const res = await post('users/create_customer', data);

      if (res.status == 200) {
        enqueueSnackbar(res.message || 'Customer Created Successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      } else {
        enqueueSnackbar(res.message || 'Error While Creating Customer', {
          variant: 'error',
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Error While Creating Customer Try Again Latter', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    } finally {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      component="form"
      onSubmit={handleSubmit(submitStock)}
    >
      {/* HEADER */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: 1 }}>
        <DialogTitle sx={{ fontSize: 20, fontWeight: 700 }}>Create Enquiry</DialogTitle>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Stack>

      {/* BODY */}
      <DialogContent sx={{ px: 2 }}>
        {/* VENDOR */}
        <Grid container spacing={2}>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <Controller
              control={control}
              name="firstName"
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="First Name"
                  error={!!errors.firstName}
                  helperText={errors.firstName?.message}
                  slotProps={{ htmlInput: { maxLength: 30 } }}
                />
              )}
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <Controller
              control={control}
              name="middelName"
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Middel Name"
                  error={!!errors.middelName}
                  helperText={errors.middelName?.message}
                  slotProps={{ htmlInput: { maxLength: 30 } }}
                />
              )}
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <Controller
              control={control}
              name="lastName"
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Last Name"
                  error={!!errors.lastName}
                  helperText={errors.lastName?.message}
                  slotProps={{ htmlInput: { maxLength: 30 } }}
                />
              )}
            />
          </Grid>

          <Grid item size={{ xs: 12, sm: 6 }}>
            <Controller
              control={control}
              name="appliedCapacity"
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Applied KW"
                  type="number"
                  error={!!errors.appliedCapacity}
                  helperText={errors.appliedCapacity?.message}
                  slotProps={{ htmlInput: { maxLength: 200 } }}
                />
              )}
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <Controller
              control={control}
              name="amount"
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Amount"
                  type="number"
                  error={!!errors.amount}
                  helperText={errors.amount?.message}
                  slotProps={{ htmlInput: { maxLength: 200 } }}
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>

      {/* FOOTER */}
      <DialogActions sx={{ p: 2 }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" type="submit">
          Creat
        </Button>
      </DialogActions>
    </Dialog>
  );
}
